import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { redirect } from 'store/Router/actions';
import { selectLocation } from 'store/Router/selectors';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';
import { Wrapper, Item } from './styled';

const isTabActive = (pathname, url) => pathname === url || pathname.startsWith(`${url}/`);

const Tab = ({ name, url }) => {
  const location = useSelector(selectLocation);
  const isSelected = isTabActive(location.pathname, url);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(redirect(url));
  };

  return (
    <Item onClick={ handleClick } isActive={ isSelected } data-tour={ name } disabled={ name === 'Weekly Reports' }>
      { name }
    </Item>
  );
};

const TabsList = ({ tabsList }) => {
  const location = useSelector(selectLocation);
  const dispatch = useDispatch();
  const enabledTabs = tabsList.filter((t) => t.enabledByRole && t.enabledByFeature);
  const activeTab = enabledTabs.find((t) => isTabActive(location.pathname, t.url));

  useTabsShortcuts({
    tabs: enabledTabs,
    activeId: activeTab?.url,
    getId: (tab) => tab.url,
    onChange: (url) => dispatch(redirect(url))
  });

  return (
    <Wrapper>
      { enabledTabs.map(({ name, url }) => <Tab key={ name } name={ name } url={ url } />) }
    </Wrapper>
  );
};

export default TabsList;
